import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

export const announcementService = {
  async getAnnouncements(page = 1, limit = 20) {
    try {
      const response = await axios.get(`${API_URL}/announcements`, {
        params: { page, limit }
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching announcements:', error);
      return { announcements: [], total: 0, totalPages: 1, page: 1 };
    }
  },

  async getAnnouncement(id) {
    const response = await axios.get(`${API_URL}/announcements/${id}`);
    return response.data.announcement;
  },

  async getUnreadCount() {
    try {
      const response = await axios.get(`${API_URL}/announcements/unread-count`);
      return response.data.unreadCount || 0;
    } catch (error) {
      console.error('Error getting announcement unread count:', error);
      return 0;
    }
  },

  async getNewAnnouncements(since) {
    try {
      const response = await axios.get(`${API_URL}/announcements/new`, {
        params: { since: since.toISOString() }
      });
      return response.data.announcements || [];
    } catch (error) {
      console.error('Error fetching new announcements:', error);
      return [];
    }
  },

  async createAnnouncement(formData) {
    const response = await axios.post(`${API_URL}/announcements`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    return response.data;
  },

  async markAsRead(id) {
    await axios.post(`${API_URL}/announcements/${id}/read`);
  },

  async markAllAsRead() {
    await axios.post(`${API_URL}/announcements/mark-all-read`);
  },

  async deleteAnnouncement(id) {
    await axios.delete(`${API_URL}/announcements/${id}`);
  },

  async vote(id, action) {
    const response = await axios.post(`${API_URL}/announcements/${id}/vote`, { action });
    return response.data;
  },

  async addComment(id, content) {
    const response = await axios.post(`${API_URL}/announcements/${id}/comments`, { content });
    return response.data;
  }
};
